module.exports = __webpack_public_path__ + "static/media/banner.d0aaa1eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/activity/inviteNew/banner.png
// module id = 1929
// module chunks = 6